import $ from 'jquery';

// Toggle mobile nav panel
$( '.js-toggle-nav-panel' ).on('click', function(e) {
	e.preventDefault();
	$( this ).parents( '.c-mobile-nav__item--has-panel' ).find( '.c-mobile-nav__panel' ).toggleClass( 'is-expanded' )
} );
